export default {
    color: {
        primary: '#0199fc',
        secondary: '#4267b2',
        border: '#e9ebee',
        light: '#f5f6f7',
        sidebar: {
            bg: '#5f6e86',
            bg_hover: '#3d485a',
            color: '#a3abbb',
            color_hover: '#dcddec',
        },
        customer: {
            trial: '#f50',
            premium: '#87d068',
        },
    },
    size: {
        container: 1200,
        space: 16,
        borderRadius: 4,
        header: 54,
    },
    font: {
        size4: 18,
    },
    menu: {
        dark: {
            color: '#7ca1bb',
        },
    },
    spacing: {
        m: 16,
        s: 18,
        xs: 14,
    },
};
